import React from 'react';
import PropTypes from 'prop-types';
import { EXPORT_TAB_RESULT_STATUSES } from '../ExportTabConstants';

import './ExportTabTooltipContent.custom.scss';
import './ExportTabTooltipContent.theme.scss';

function ExportTabTooltipContent(props) {
  const { exportResult } = props;
  const { progress, status } = exportResult;

  if (status === EXPORT_TAB_RESULT_STATUSES.STARTED) {
    return (
      <div className="exportTab__tooltip_content">
        <div className="exportTab__tooltip_content_message">Starting Export</div>
      </div>
    );
  }

  if (status === EXPORT_TAB_RESULT_STATUSES.FINISHED) {
    return (
      <div className="exportTab__tooltip_content">
        <div className="exportTab__tooltip_content_message">Your export is ready</div>
      </div>
    );
  }

  if (status === EXPORT_TAB_RESULT_STATUSES.CONNECTION_ERROR) {
    return (
      <div className="exportTab__tooltip_content">
        <div className="exportTab__tooltip_content_icon">!</div>
        <div className="exportTab__tooltip_content_message">Your connection to the server was interrupted</div>
      </div>
    );
  }

  return (
    <div className="exportTab__tooltip_content">
      <div className="progressBar">
        <div className="progressBar__title">Progress</div>
        <div className="progressBar__content">
          <div className="progressBar__content progressBar__content-inner" style={{ width: `${progress}%` }} />
        </div>
        <div className="progressBar__percentage">{`${progress}%`}</div>
      </div>
    </div>
  );
}

ExportTabTooltipContent.propTypes = {
  exportResult: PropTypes.object,
};

export default ExportTabTooltipContent;
